import WysiwygBlock from '@/components/blocks/WysiwygBlock';
import React, { Ref } from 'react';
import { HTMLFieldProps, connectField } from 'uniforms';

export type LongTextFieldProps = HTMLFieldProps<
  string,
  HTMLDivElement,
  { inputRef?: Ref<HTMLTextAreaElement> }
>;

function Wysiwyg({
  disabled,
  id,
  inputRef,
  label,
  name,
  onChange,
  placeholder,
  readOnly,
  value,
  ...props
}: LongTextFieldProps) {
  return (
    <div
      className="relative flex flex-wrap items-center gap-4 text-wrap py-2"
      style={{ overflowWrap: 'anywhere', overflowX: 'hidden' }}
    >
      <WysiwygBlock html={value || ''} styles="text-sm" />
    </div>
  );
}

export default connectField<LongTextFieldProps>(Wysiwyg, { kind: 'leaf' });
